import React, { useEffect, useState, useMemo } from 'react'
import Particles, { initParticlesEngine } from '@tsparticles/react'

import { loadSlim } from '@tsparticles/slim'
import { type ISourceOptions } from '@tsparticles/engine'

const ParticleBackground: React.FC = () => {
  // Estado para saber si el motor de partículas ya está inicializado
  const [engineLoaded, setEngineLoaded] = useState(false)

  useEffect(() => {
    // Inicializa el engine de tsParticles una sola vez
    initParticlesEngine(async (engine) => {
      // Carga la configuración "slim" con las características por defecto más comunes
      await loadSlim(engine)
    }).then(() => {
      // Una vez cargado, actualiza el estado
      setEngineLoaded(true)
    })
  }, [])

  // Configuración de las partículas (objeto de opciones)
  const particlesOptions: ISourceOptions = useMemo(
    () => ({
      background: {
        color: { value: 'transparent' },
      },
      fpsLimit: 144, // límite de FPS para optimización
      interactivity: {
        events: {
          onClick: { enable: true, mode: 'push' }, // al hacer clic, agrega partículas
          onHover: { enable: true, mode: 'repulse' }, // al pasar el cursor, repele partículas
        },
        modes: {
          push: { quantity: 2 }, // # de partículas agregadas en push
          repulse: { distance: 100, duration: 0.4 }, // distancia y duración del efecto repulse
        },
      },
      particles: {
        color: { value: '#ffffff' }, // color de las partículas
        links: {
          color: '#ffffff',
          distance: 150,
          enable: true,
          opacity: 0.5,
          width: 1,
        },
        move: {
          // movimiento de las partículas
          direction: 'none', // sin dirección fija (aleatorio)
          enable: true,
          speed: 2, // velocidad de movimiento
          random: false,
          straight: false,
          outModes: {
            default: 'bounce', // rebotan al llegar al borde del canvas
          },
        },
        number: {
          value: 300, // cantidad de partículas
          density: { enable: true }, // distribución densa (ocupa todo el espacio)
        },
        opacity: {
          value: 0.5, // opacidad semi-transparente
        },
        shape: {
          type: 'circle', // forma circular (puedes usar "square", "star", etc.)
        },
        size: {
          value: { min: 1, max: 5 }, // tamaño aleatorio entre 1 y 5 px
        },
      },
      detectRetina: true, // alta definición en pantallas Retina
    }),
    []
  )

  // Renderiza el componente de partículas una vez que el engine está listo
  if (!engineLoaded) return null // Espera a que las partículas se inicialicen
  return <Particles id="tsparticles" options={particlesOptions} />
}

export default ParticleBackground
